(function () {
  'use strict';

  // V160 18/10/2026 : plus aucun texte affiché écrit ici. Les traductions viennent des fichiers de langue du thème
  // (clés ma160.l10n.* et ma160.l10n_facets.*), injectées par le snippet ma160-l10n dans <script id="ma-l10n">.
  // Les textes français qui restent dans ce fichier sont des textes à reconnaître (sortie des applis, des remises et des
  // filtres, saisie dans la langue principale de la boutique), jamais affichés par ce script.
  var L = {};
  try { L = JSON.parse(document.getElementById('ma-l10n').textContent) || {}; } catch (e) { L = {}; }
  var copy = L.copy;
  if (!copy) return;
  var primary = L.primary === true;
  var locale = L.language || (document.documentElement.lang || 'fr').toLowerCase().split('-')[0];
  var country = (window.Shopify && window.Shopify.country || '').toUpperCase();
  copy.uploadColors = copy.upload_colors; copy.kitContents = copy.kit_contents; copy.paintQuality = copy.paint_quality;
  copy.canvasOptions = copy.canvas_options; copy.customerGallery = copy.customer_gallery; copy.customerReviews = copy.customer_reviews;
  copy.productImage = copy.product_image; copy.perPainting = copy.per_painting;

  // V160 18/10/2026, 3e passe : réponse livraison utilisée seulement si elle est écrite dans la langue de la page (shipping_lang,
  // voir snippet ma160-l10n) ; sinon rien n'est remplacé, comme avant V160 hors anglais.
  var shippingFaq = (L.shipping && L.shipping_lang === locale) ? L.shipping : null;

  // Valeurs de filtres saisies en français dans l'admin -> clé de traduction ma160.l10n_facets.*
  var facetKeys = {
    "Calendrier de l'avent": 'advent_calendar', 'Coffret 4 mini-toiles': 'set_4', 'Coffret 6 mini-toiles': 'set_6',
    'Pancarte 20 × 14 cm': 'door_sign', 'Toile': 'canvas', 'Confirmé': 'advanced', 'Débutant': 'beginner',
    'Intermédiaire': 'intermediate', 'Bleus': 'blues', 'Coloré & vif': 'colorful', 'Pastel': 'pastel', 'Roses': 'pinks',
    'Sombre': 'dark', 'Tons chauds': 'warm', 'Tons froids': 'cool', 'Verts': 'greens', 'Abstrait': 'abstract',
    'Affiche vintage': 'vintage_poster', 'Aquarelle': 'watercolor', 'Art naïf': 'naive', 'Cartoon & Kawaii': 'cartoon',
    'Illustration moderne': 'modern_illustration', 'Impressionniste': 'impressionist', 'Pop art': 'pop_art', 'Réaliste': 'realistic'
  };
  var facetCopy = {};
  if (!primary) Object.keys(facetKeys).forEach(function (source) {
    var target = L.facets && L.facets[facetKeys[source]];
    if (target && target !== source) facetCopy[source] = target;
  });

  var uploadKitCopy = primary ? null : {
    language: locale, required: copy.upload_required, add: copy.upload_add, choose: copy.upload_choose, change: copy.upload_change,
    android: copy.upload_android, ios: copy.upload_ios
  };

  function localizeUploadKitConfig() {
    if (!uploadKitCopy || !window.UploadKit || !window.UploadKit.config) return false;
    window.UploadKit.config.enableMultiLanguage = true;
    (window.UploadKit.config.uploaders || []).forEach(function (uploader) {
      uploader.language = uploadKitCopy.language;
      uploader.requiredMessage = uploadKitCopy.required;
      uploader.requiredButtonText = uploadKitCopy.add;
      uploader.buttonText = uploadKitCopy.choose;
      uploader.buttonUploadedText = uploadKitCopy.change;
      if (uploadKitCopy.android) uploader.androidFbMessage = uploadKitCopy.android;
      if (uploadKitCopy.ios) uploader.iosFbMessage = uploadKitCopy.ios;
    });
    return true;
  }

  var uploadKitAttempts = 0;
  var uploadKitTimer = window.setInterval(function () {
    uploadKitAttempts += 1;
    if (localizeUploadKitConfig() || uploadKitAttempts >= 100) window.clearInterval(uploadKitTimer);
  }, 10);

  function cssText(value) {
    return String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  var style = document.createElement('style');
  style.setAttribute('data-ma-localization-fixes', locale);
  style.textContent = [
    // Native numbered labels already contain their translated heading.
    'variant-selects:has([id*="option_3_label_container"]) .product-form__label-container:has(.form__label-text)::after{content:none!important}',
    'variant-selects:has([id*="option_3_label_container"]) [id*="option_1_label_container"]:not(:has(.form__label-text))::after{content:"' + cssText(copy.size) + '"!important}',
    'variant-selects:has([id*="option_3_label_container"]) [id*="option_2_label_container"]:not(:has(.form__label-text))::after{content:"' + cssText(copy.canvas) + '"!important}',
    'variant-selects:has([id*="option_3_label_container"]) [id*="option_3_label_container"]:not(:has(.form__label-text))::after{content:"' + cssText(copy.colors) + '"!important}',
    'variant-selects:has([id*="option_3_label_container"]) .product-form__input--pills input[value="Toile sur châssis"]+label::before{content:"' + cssText(copy.popular) + '"!important}',
    'variant-selects:has([id*="option_3_label_container"]) input[value="24 couleurs"]+label::after{content:"' + cssText(copy.beginner) + '"!important}',
    'variant-selects:has([id*="option_3_label_container"]) input[value="36 couleurs"]+label::after{content:"' + cssText(copy.plus6) + '"!important}',
    'variant-selects:has([id*="option_3_label_container"]) input[value="48 couleurs"]+label::after{content:"' + cssText(copy.plus12) + '"!important}',
    'variant-selects:has([id*="option_3_label_container"]) input[value="40×50 cm"]+label::after{content:"' + cssText(copy.chosen) + '"!important}'
  ].join('\n');
  document.head.appendChild(style);

  var exactText = {
    'Choisissez votre taille': copy.size,
    'Choisissez votre toile': copy.canvas,
    'Format de la toile': primary ? 'Format de la toile' : copy.canvas,
    'Choisissez le nombre de couleurs': copy.colors,
    'Choisissez vos couleurs': copy.uploadColors,
    'Ajoutez votre photo': copy.upload,
    'Pour débuter': copy.beginner,
    '♥ La plus choisie': copy.chosen,
    'La plus populaire ✨': copy.popular,
    '+6 h de peinture': copy.plus6,
    '+12 h de peinture': copy.plus12
  };

  // Titres des remises automatiques (saisis en français dans l'admin) -> clés ma160.l10n.discount_*
  var discountTitles = primary ? {} : {
    '2 achetés = 1 offert': copy.discount_bogo,
    '9 Pinceaux offerts': copy.discount_brushes_9,
    '3 Pinceaux offerts': copy.discount_brushes_3,
    'Chevalet offert': copy.discount_easel
  };

  function translate(root) {
    if (!root || root.nodeType !== 1) return;

    if (shippingFaq) {
      var faqItems = Array.prototype.slice.call(root.querySelectorAll('.ma-faq-item'));
      if (root.matches('.ma-faq-item')) faqItems.unshift(root);
      faqItems.forEach(function (item) {
        var summary = item.querySelector('summary');
        var answer = item.querySelector('.ma-faq-answer');
        if (summary && answer && L.shipping_q && summary.textContent.trim() === L.shipping_q && answer.textContent.trim() !== shippingFaq) {
          answer.textContent = shippingFaq;
        }
      });
    }

    var textTargets = Array.prototype.slice.call(root.querySelectorAll('.ma-upload-step__txt, .product-form__label-container, .product-form__input--pills label'));
    if (root.matches('.ma-upload-step__txt, .product-form__label-container, .product-form__input--pills label')) textTargets.unshift(root);
    textTargets.forEach(function (element) {
      var textWalker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      var targetNode;
      while ((targetNode = textWalker.nextNode())) {
        var current = targetNode.textContent.trim();
        if (exactText[current] && exactText[current] !== current) targetNode.textContent = targetNode.textContent.replace(current, exactText[current]);
      }
    });

    if (!primary) {
      var facetTargets = Array.prototype.slice.call(root.querySelectorAll('.facet-item span'));
      if (root.matches('.facet-item span')) facetTargets.unshift(root);
      facetTargets.forEach(function (element) {
        var current = element.textContent.trim();
        Object.keys(facetCopy).some(function (source) {
          if (current !== source && current.indexOf(source + ' (') !== 0) return false;
          // Guard: writing an identical string (e.g. "Pop art" -> "Pop art") still re-creates the text node,
          // which re-triggers the MutationObserver and locks the page in an endless loop (seen 17 Sep 2026).
          var nextText = element.textContent.replace(source, facetCopy[source]);
          if (nextText !== element.textContent) element.textContent = nextText;
          return true;
        });
      });

      // V170 21/10/2026 : Royaume-Uni en anglais, les filtres de Shopify ignorent les traductions propres au marché :
      // orthographe britannique et tailles en cm sur les libellés de filtres (mots à reconnaître, pas de texte nouveau).
      if (country === 'GB' && locale === 'en') {
        var gbTargets = facetTargets.concat(Array.prototype.slice.call(root.querySelectorAll('.active-facets__button-inner, .active-facets__button span, .facets__pill')));
        gbTargets.forEach(function (element) {
          if (element.children.length) return;
          var t = element.textContent;
          var n = t.replace(/(C|c)olor(s|ed|ful|ing)?\b/g, function (m, c, end) { return c + 'olour' + (end || ''); })
            .replace(/\b(F|f)avorite(s)?\b/g, function (m, f, s2) { return f + 'avourite' + (s2 || ''); })
            .replace(/\b(G|g)ray\b/g, function (m, g) { return g + 'rey'; })
            .replace(/\d+(?:\.\d+)?\s*[x×]\s*\d+(?:\.\d+)?\s*(?:"|″|in\b)\s*\((\d+\s*[x×]\s*\d+\s*cm)\)/g, '$1');
          if (n !== t) element.textContent = n;
        });
      }

      if (uploadKitCopy) {
        var uploadKitTexts = {};
        uploadKitTexts['Veuillez télécharger un fichier avant d\'ajouter le produit à votre panier.'] = uploadKitCopy.required;
        uploadKitTexts['Ajouter une image'] = uploadKitCopy.add;
        uploadKitTexts['Cliquez ICI pour choisir votre photo'] = uploadKitCopy.choose;
        uploadKitTexts["Modifier l'image"] = uploadKitCopy.change;
        var uploadTargets = Array.prototype.slice.call(root.querySelectorAll('.uploadkit, .uploadkit *'));
        if (root.matches('.uploadkit, .uploadkit *')) uploadTargets.unshift(root);
        uploadTargets.forEach(function (element) {
          if (element.children.length) return;
          var current = element.textContent.trim();
          if (uploadKitTexts[current]) element.textContent = element.textContent.replace(current, uploadKitTexts[current]);
        });
      }
    }

    if (!primary) {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      var textNode;
      while ((textNode = walker.nextNode())) {
        var parent = textNode.parentElement;
        if (!parent || /^(SCRIPT|STYLE|TEXTAREA|OPTION)$/.test(parent.tagName)) continue;
        var trimmed = textNode.textContent.trim();
        if (trimmed === 'Offert' || trimmed === 'Offert*') {
          textNode.textContent = textNode.textContent.replace(trimmed, copy.free + (trimmed.endsWith('*') ? '*' : ''));
        } else if (discountTitles[trimmed]) {
          // Titres des remises automatiques Shopify (non traduisibles côté admin), affichés dans le panier.
          textNode.textContent = textNode.textContent.replace(trimmed, discountTitles[trimmed]);
        } else {
          var priceMatch = trimmed.match(/^soit\s+(.+)\/peinture$/i);
          if (priceMatch) textNode.textContent = textNode.textContent.replace(trimmed, copy.perPainting.replace('[price]', priceMatch[1]));
        }
      }
    }

    var photoButtons = Array.prototype.slice.call(root.querySelectorAll('[aria-label="Supprimer la photo"]'));
    if (root.matches('[aria-label="Supprimer la photo"]')) photoButtons.unshift(root);
    photoButtons.forEach(function (element) {
      element.setAttribute('aria-label', copy.remove);
    });
    root.querySelectorAll('[aria-label="Nos collections"]').forEach(function (element) {
      element.setAttribute('aria-label', copy.collections);
    });

    root.querySelectorAll('a[href^="https://maisonartsen.fr/"], a[href^="http://maisonartsen.fr/"]').forEach(function (element) {
      var url = new URL(element.href);
      element.href = window.location.origin + url.pathname + url.search + url.hash;
    });

    if (!primary) {
      var pageTitle = document.querySelector('h1');
      var galleryAlt = pageTitle ? pageTitle.textContent.trim() : '';
      var images = Array.prototype.slice.call(root.querySelectorAll('img[alt]'));
      if (root.matches('img[alt]')) images.unshift(root);
      images.forEach(function (image) {
        var source = image.getAttribute('src') || '';
        var alt = image.getAttribute('alt') || '';
        var translatedAlt = '';
        // Keep native English alt text; only repair French fallbacks.
        if (alt.toLowerCase() !== '5 étoiles sur 5' && !/\b(peinture|toile|coffret|pinceaux?|numéro|étoiles?|clientes?|livraison|cadre)\b/i.test(alt)) return;
        if (source.indexOf('contenu-du-coffret') !== -1) translatedAlt = copy.kitContents;
        else if (source.indexOf('qualite-peintures-numeros') !== -1) translatedAlt = copy.paintQuality;
        else if (source.indexOf('toile-roulee-ou-sur-chassis') !== -1) translatedAlt = copy.canvasOptions;
        else if (source.indexOf('avis-clients-maison-artsen') !== -1) translatedAlt = copy.customerGallery;
        else if (source.indexOf('commentaire-client-maison-artsen') !== -1) translatedAlt = copy.customerReviews;
        else if (alt.toLowerCase() === '5 étoiles sur 5') translatedAlt = copy.rating;
        else if (image.closest('[id^="MediaGallery-"], [id^="sticky-atc-"]') && galleryAlt) translatedAlt = galleryAlt + ' – Maison Artsen';
        else if (/\b(peinture|toile|coffret|pinceaux?|numéro|étoiles?|clientes?|livraison|cadre)\b/i.test(alt)) translatedAlt = copy.productImage;
        if (translatedAlt && image.getAttribute('alt') !== translatedAlt) image.setAttribute('alt', translatedAlt);
      });
    }

    root.querySelectorAll('a, button').forEach(function (element) {
      if (element.textContent.indexOf('accessibility.scroll_to_top') !== -1) {
        element.textContent = copy.scroll;
        element.setAttribute('aria-label', copy.scroll);
      }
    });
  }

  function run() { translate(document.documentElement); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.setTimeout(run, 250);
  window.setTimeout(run, 1000);
  window.setTimeout(run, 2500);
  document.addEventListener('shopify:section:load', run);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'characterData') {
        translate(mutation.target.parentElement);
        return;
      }
      if (mutation.type === 'attributes') {
        translate(mutation.target);
        return;
      }
      Array.prototype.forEach.call(mutation.addedNodes, function (node) {
        if (node.nodeType === 1) translate(node);
        else if (node.nodeType === 3) translate(node.parentElement);
      });
    });
  }).observe(document.documentElement, { childList: true, characterData: true, attributes: true, attributeFilter: ['alt'], subtree: true });
})();
